/* 
Author:Lamiaa Moustafa
Desc: Authentication page UI
*/

import React from "react";
import { Link } from "react-router-dom";
import {
  AuthDiv,
  AuthBtnDiv,
  TransDiv,
} from "../../Styles/styledComponents/Divs";
import { Slogan } from "../../components/text/Slogan";
import { FormInput } from "../../components/inputs/FormInput";
import { Button1st2911 } from "../../components/buttons/Button1st2911";
import { EmailInput } from "../../Styles/styledComponents/Inputs";
import RadioButton from "../../components/inputs/RadioButton";

const Authentication = () => {
 
  return (
    <>
      <TransDiv>
        <Slogan data={{ label: "VERIFY YOUR" }} />
        <Slogan data={{ label: "ACCOUNT" }} />
       
        <RadioButton className="AccentColor" data={{type:"radio", label:"Send text to"}}/>
        <RadioButton data={{type:"radio", label:"Send email to"}}/>
      
        <AuthDiv>
        <FormInput 
          data={{
            type: "number",
            placeholder: "Authentication code",
            customStyle: EmailInput,
          //  width:"50%"  
          }}
        />
          <AuthBtnDiv>
            <Button1st2911 data={{ label: "VERIFY" }} />
            <Button1st2911 data={{ label: "LOGOUT" }} />
          </AuthBtnDiv>
          <Link className="linkStyle" to="">
            Send code again?
          </Link>
        </AuthDiv>
      </TransDiv>
    </>
  );
};
export default Authentication;
